<template>
  <div>
    <v-data-table
      v-model="selectedItens"
      :loading="loadingTable"
      :headers="headers"
      :items="reserves"
      sort-by="calories"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :expanded.sync="expanded"
      show-expand
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,

      }"
      @click:row="selectItem"
    >
      <template v-slot:top>
        <div class="group-toolbar">
          <div class="group-toolbar__heading">
            <h1>Reservas de grupo</h1>
            <p>Consulte grupos existentes ou reúna reservas confirmadas.</p>
          </div>
          <div class="group-toolbar__controls">
            <v-text-field
              v-model="search"
              class="group-toolbar__search"
              placeholder="ID, empresa, solicitante ou localizador"
              :append-icon="icons.mdiMagnify"
              aria-label="Localizar reserva de grupo"
              outlined
              dense
              clearable
              hide-details
              @click:append="searchItems()"
              @keyup.enter="searchItems()"
              @click:clear="searchItems()"
            ></v-text-field>
            <v-btn
              color="primary"
              class="group-toolbar__new-button"
              @click="openCreateGroupDialog"
            >
              <v-icon
                left
                small
              >
                {{ icons.mdiPlus }}
              </v-icon>
              Nova reserva de grupo
            </v-btn>
          </div>
        </div>
      </template>

      <template v-slot:item.guests="{ item }">
        {{ allGuests(item) }}
      </template>

      <template v-slot:item.ids="{ item }">
        {{ getIds(item) }}
      </template>

      <template v-slot:item.room_category.description="{ item }">
        {{ categorySummary(item) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="group-row-actions">
          <v-btn
            text
            small
            color="primary"
            class="group-row-actions__add"
            :disabled="!item.company_id"
            @click.stop="openJoinDialog(item)"
          >
            <v-icon
              left
              small
            >
              {{ icons.mdiAccountMultiplePlus }}
            </v-icon>
            Adicionar reservas
          </v-btn>
          <v-btn
            text
            small
            color="primary"
            class="group-row-actions__account"
            @click.stop="openGroupAccount(item)"
          >
            <v-icon
              left
              small
            >
              {{ icons.mdiBookAccount }}
            </v-icon>
            {{ item.accounts_exists ? 'Acessar conta master' : 'Abrir conta master' }}
          </v-btn>
        </div>
      </template>

      <template v-slot:item.status="{ item }">
        <div
          v-if="confirmStatus(item) == 'misto'"
          class="d-flex flex-column"
        >
          <v-chip
            v-for="(statusItem, index) in getMixedStatusChips(item)"
            :key="index"
            :color="statusItem.color"
            :text-color="statusItem.textColor"
            x-small
            class="mb-1"
          >
            {{ statusItem.label }}
          </v-chip>
        </div>
        <v-chip
          v-if="confirmStatus(item) == 'confirmed'"
          color="info"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'precheckin'"
          :color="preCheckinComplete(item) ? '#6CBF84' : '#FB8C00'"
          :text-color="preCheckinComplete(item) ? '#1F4D2E' : '#FFFFFF'"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item)== 'checkin'"
          color="success"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'checkout'"
          color="error"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'canceled'"
          color="secondary"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'pending'"
          color="orange"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'no-show'"
          color="warning"
        >
          {{ reserved(item) }}
        </v-chip>
      </template>
      <template v-slot:item.room="{ item }">
      </template>
      <template v-slot:item.check_in="{ item }">
        {{ formatDate(item.check_in) }}
      </template>
      <template v-slot:item.check_out="{ item }">
        {{ formatDate(item.check_out) }}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td
          :colspan="headers.length"
          class="pa-0"
        >
          <v-expand-transition>
            <v-data-table
              :headers="subHeaders"
              :items="item.reserves"
              dense
              hide-default-footer
            >
              <template v-slot:item.status="{ item }">
                <v-chip
                  v-if="item.status == 'confirmed'"
                  color="info"
                >
                  Confirmado
                </v-chip>
                <v-chip
                  v-if="item.status == 'precheckin'"
                  :color="preCheckinComplete(item) ? '#6CBF84' : '#FB8C00'"
                  :text-color="preCheckinComplete(item) ? '#1F4D2E' : '#FFFFFF'"
                >
                  Pré Check-in
                </v-chip>
                <v-chip
                  v-if="item.status == 'checkin'"
                  color="success"
                >
                  Check-in
                </v-chip>
                <v-chip
                  v-if="item.status == 'checkout'"
                  color="error"
                >
                  Check-out
                </v-chip>
                <v-chip
                  v-if="item.status == 'canceled'"
                  color="secondary"
                >
                  Cancelado
                </v-chip>
                <v-chip
                  v-if="item.status == 'pending'"
                  color="orange"
                >
                  Pendente
                </v-chip>
                <v-chip
                  v-if="item.status == 'no-show'"
                  color="warning"
                >
                  No-Show
                </v-chip>
              </template>

              <template v-slot:item.guests="{ item }">
                {{ allGuests(item) }}
              </template>

              <template v-slot:item.check_in="{ item }">
                {{ formatDate(item.check_in) }}
              </template>

              <template v-slot:item.check_out="{ item }">
                {{ formatDate(item.check_out) }}
              </template>
            </v-data-table>
          </v-expand-transition>
        </td>
      </template>

      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <v-card class="mt-2">
      <v-card-subtitle>
        Clique no registro para visualizar a observação:
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            class="text-center"
          >
            <p v-text="selectedItens.length > 0 ? selectedItens[0].obs : ''"></p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="createGroupDialog"
      max-width="1120"
      persistent
      scrollable
    >
      <v-card class="create-group-dialog">
        <BarTitleDialog
          title="Criar grupo"
          @close="closeCreateGroupDialog"
        ></BarTitleDialog>
        <v-card-text class="pt-5">
          <v-alert
            dense
            text
            type="info"
            class="mb-4"
          >
            Selecione ao menos duas reservas da mesma empresa. A lista será filtrada após a primeira seleção.
          </v-alert>

          <div class="create-group-fields">
            <v-text-field
              v-model="createGroupSearch"
              :append-icon="icons.mdiMagnify"
              label="Localizar reserva"
              placeholder="ID, empresa, solicitante, hóspede ou categoria"
              outlined
              dense
              clearable
              hide-details
            ></v-text-field>
            <v-text-field
              v-model="createGroupRequester"
              label="Solicitante do grupo (opcional)"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>

          <v-data-table
            v-model="selectedCreateReserves"
            :headers="createGroupHeaders"
            :items="visibleCreateCandidates"
            :loading="loadingCreateCandidates"
            :search="createGroupSearch"
            :custom-filter="createCandidateFilter"
            item-key="id"
            show-select
            :mobile-breakpoint="0"
            class="mt-4 create-group-table"
            :footer-props="{
              itemsPerPageText: 'Itens por página',
              itemsPerPageOptions: [5, 10, 15, -1],
            }"
          >
            <template v-slot:item.guests="{ item }">
              {{ allGuests(item) || 'Não informado' }}
            </template>
            <template v-slot:item.check_in="{ item }">
              {{ formatDate(item.check_in) }}
            </template>
            <template v-slot:item.check_out="{ item }">
              {{ formatDate(item.check_out) }}
            </template>
            <template v-slot:no-data>
              Nenhuma reserva confirmada e sem grupo foi encontrada.
            </template>
            <template v-slot:loading>
              Carregando reservas...
            </template>
          </v-data-table>

          <v-textarea
            v-model="createGroupObservation"
            label="Observação do grupo (opcional)"
            outlined
            dense
            rows="2"
            hide-details
            class="mt-4"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="px-6 pb-5 create-group-actions">
          <div>
            <strong>{{ selectedCreateReserves.length }}</strong>
            reserva(s) selecionada(s)
            <span
              v-if="selectedCreateCompany"
              class="grey--text text--darken-1"
            >
              · {{ selectedCreateCompany.fantasy_name }}
            </span>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            text
            :disabled="savingCreateGroup"
            @click="closeCreateGroupDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="savingCreateGroup"
            :disabled="selectedCreateReserves.length < 2"
            @click="saveCreatedGroup"
          >
            Criar reserva de grupo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="joinDialog"
      max-width="1050"
      persistent
    >
      <v-card>
        <BarTitleDialog
          title="Adicionar reservas ao grupo"
          @close="closeJoinDialog"
        ></BarTitleDialog>
        <v-card-text class="pt-5">
          <v-alert
            dense
            outlined
            type="info"
            class="mb-4"
          >
            Selecione reservas confirmadas e sem outro grupo da empresa
            <strong>{{ joinGroup && joinGroup.company ? joinGroup.company.fantasy_name : '' }}</strong>.
          </v-alert>

          <v-text-field
            v-model="joinSearch"
            :append-icon="icons.mdiMagnify"
            label="Localizar reserva"
            placeholder="ID, solicitante, hóspede ou categoria"
            outlined
            dense
            clearable
            hide-details
            class="mb-4"
          ></v-text-field>

          <v-data-table
            v-model="selectedJoinReserves"
            :headers="joinHeaders"
            :items="joinCandidates"
            :loading="loadingJoinCandidates"
            :search="joinSearch"
            :custom-filter="joinCandidateFilter"
            item-key="id"
            show-select
            :footer-props="{
              itemsPerPageText: 'Itens por pagina',
              itemsPerPageOptions: [5, 10, 15, -1],
            }"
          >
            <template v-slot:item.guests="{ item }">
              {{ allGuests(item) }}
            </template>
            <template v-slot:item.check_in="{ item }">
              {{ formatDate(item.check_in) }}
            </template>
            <template v-slot:item.check_out="{ item }">
              {{ formatDate(item.check_out) }}
            </template>
            <template v-slot:no-data>
              Nenhuma reserva confirmada disponível para esta empresa.
            </template>
            <template v-slot:loading>
              Carregando reservas...
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="px-6 pb-5">
          <span class="text-caption grey--text">
            {{ selectedJoinReserves.length }} reserva(s) selecionada(s)
          </span>
          <v-spacer></v-spacer>
          <v-btn
            text
            :disabled="savingJoin"
            @click="closeJoinDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="savingJoin"
            :disabled="selectedJoinReserves.length === 0"
            @click="saveJoinedReserves"
          >
            Adicionar ao grupo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

// import MsgDelete from '@/components/MsgDelete.vue'
import {
  mdiClose,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiCloseCircleOutline,
  mdiPrinter,
  mdiBookAccount,
  mdiAccountMultiplePlus,
  mdiMagnify,
  mdiCurrencyUsd,
  mdiFilter,
  mdiMessageOutline,
} from '@mdi/js'
import { mapActions } from 'vuex'
import NoDataTable from '@/components/NoDataTable.vue'
import DialogReserve from './_components/DialogReserve.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {
  components: {
    NoDataTable,
    DialogReserve,
    BarTitleDialog,
  },
  data: () => ({
    expanded: [],
    selectedItens: [],
    loadingUserAdmin: false,
    userAdmin: false,
    cancelCashId: null,
    loadingOpenedCashs: false,
    cashItems: [],
    loadingCancel: false,
    justifyCancel: '',
    dialogCancel: false,
    dialogFilter: false,
    filter: {},
    search: '',
    dialogNewGuest: false,
    loadingTable: false,
    createGroupDialog: false,
    createCandidates: [],
    selectedCreateReserves: [],
    createGroupSearch: '',
    createGroupRequester: '',
    createGroupObservation: '',
    loadingCreateCandidates: false,
    savingCreateGroup: false,
    joinDialog: false,
    joinGroup: null,
    joinCandidates: [],
    selectedJoinReserves: [],
    joinSearch: '',
    loadingJoinCandidates: false,
    savingJoin: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    dialogDelete: false,
    dialog: false,
    loading: false,
    itemsStatus: [
      { text: 'Checkin', value: 'checkin' },
      { text: 'Checkout', value: 'checkout' },
      { text: 'Cancelado', value: 'canceled' },
      { text: 'Confirmado', value: 'confirmed' },
      { text: 'Pré Check-in', value: 'precheckin' },
      { text: 'Pendente', value: 'pending' },
      { text: 'No-Show', value: 'no-show' },
      { text: 'Misto', value: 'misto' },
    ],
    headers: [
      {
        text: 'ID',
        align: 'center',
        value: 'ids',
      },
      {
        text: 'EMPRESA',
        value: 'company.fantasy_name',
        sortable: false,
      },

      {
        text: 'SOLICITANTE',
        value: 'requester',
        sortable: false,
      },

      {
        text: 'CATEGORIA',
        value: 'room_category.description',
        sortable: false,
      },
      {
        text: 'QUARTOS',
        value: 'qtd_room',
      },
      {
        text: 'CHECKIN',
        value: 'check_in',
        sortable: false,
      },
      {
        text: 'CHECKOUT',
        value: 'check_out',
        sortable: false,
      },
      {
        text: 'STATUS',
        value: 'status',
        sortable: false,
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        align: 'end',
        width: 220,
      },
    ],
    subHeaders: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
      },
      {
        text: 'EMPRESA',
        value: 'company.fantasy_name',
      },
      {
        text: 'HÓSPEDES',
        value: 'guests',
      },
      {
        text: 'CHECKIN',
        value: 'check_in',
      },
      {
        text: 'CHECKOUT',
        value: 'check_out',
      },
      {
        text: 'STATUS',
        value: 'status',
      },

    ],
    joinHeaders: [
      { text: 'ID', value: 'id' },
      { text: 'SOLICITANTE', value: 'requester' },
      { text: 'HÓSPEDES', value: 'guests', sortable: false },
      { text: 'CATEGORIA', value: 'room_category.description' },
      { text: 'CHECKIN', value: 'check_in' },
      { text: 'CHECKOUT', value: 'check_out' },
    ],
    createGroupHeaders: [
      { text: 'ID', value: 'id' },
      { text: 'EMPRESA', value: 'company.fantasy_name' },
      { text: 'SOLICITANTE', value: 'requester' },
      { text: 'HÓSPEDES', value: 'guests', sortable: false },
      { text: 'CATEGORIA', value: 'room_category.description' },
      { text: 'CHECK-IN', value: 'check_in' },
      { text: 'CHECK-OUT', value: 'check_out' },
    ],
    reserves: [],
    editedIndex: -1,
    editedItem: {},
    editedDefault: {
      check_in: '',
      check_out: '',
      company_id: '',
      room: [],
      tariff_manual: 'not',
      with_iss: 'not',
    },
    options: {},
    tab: null,
    items: [
      {
        tab: 'One',
        content: 'Tab 1 Content',
      },
      {
        tab: 'Two',
        content: 'Tab 2 Content',
      },
    ],
    icons: {
      mdiBookAccount,
      mdiAccountMultiplePlus,
      mdiMagnify,
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
      mdiCloseCircleOutline,
      mdiPrinter,
      mdiCurrencyUsd,
      mdiFilter,
      mdiMessageOutline,
    },
  }),

  computed: {
    selectedCreateCompany() {
      return this.selectedCreateReserves[0] && this.selectedCreateReserves[0].company
    },
    visibleCreateCandidates() {
      if (!this.selectedCreateReserves.length) return this.createCandidates

      const companyId = this.selectedCreateReserves[0].company_id

      return this.createCandidates.filter(candidate => candidate.company_id === companyId)
    },
    formTitle() {
      return this.editedIndex === -1 ? 'Nova Reserva' : 'Editar Reserva'
    },
    bagFilter() {
      if (this.filter.status == null) {
        delete this.filter.status
      }

      return Object.keys(this.filter).length
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
    options: {
      handler() {
        this.initialize()
      },
    },
  },

  created() {
    this.initialize()

    // carrega o select rooms do dialog reserve
    this.loadRooms()

    // carrega o select categoria de quartos do dialog reserve
    this.loadRoomCategories()

    // carrega o select tariffs
    this.loadTariffs()
  },

  methods: {

    ...mapActions('select', ['loadRooms', 'loadRoomCategories', 'loadTariffs']),
    ...mapActions('reserve', [
      'getAll',
      'store',
      'update',
      'printVoucher',
      'getReserveItems',
      'cancelReserve',
      'getOpenedCashs',
      'getUser',
      'getCompletedReserve',
      'getGroupReserve',
      'getGroupJoinCandidates',
      'getGroupCreationCandidates',
      'createGroupFromReservations',
      'attachReservationsToGroup',
    ]),

    initialize() {
      this.loadingTable = true
      this.selectedItens = []
      const { page, itemsPerPage } = this.options

      const payload = {
        itemsPerPage: itemsPerPage || 10,
        page,
        search: this.search,
      }
      this.getGroupReserve(payload)
        .then(response => {
          this.reserves = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    searchItems() {
      this.options = {}
      this.initialize()
    },
    requester(item) {
      if (item.requester == null) {
        if (item.company) {
          return item.company.fantasy_name
        } if (item.guest.length > 0) {
          return item.guest[0].name
        } if (item.guest_unknown.length > 0) {
          return item.guest_unknown[0].name
        }
      } else {
        return item.requester
      }
    },

    firstGuest(item) {
      if (item.guest.length > 0) {
        return item.guest[0].name
      } if (item.guest_unknown.length > 0) {
        return item.guest_unknown[0].name
      }

      return ''
    },

    allGuests(item) {
      const guests = item.guest || []
      const guestsUnknown = item.guest_unknown || []

      if (guests.length > 0) {
        return guests.map(guest => guest.name).join(', ')
      } if (guestsUnknown.length > 0) {
        return guestsUnknown.map(guest => guest.name).join(', ')
      }

      return ''
    },

    categorySummary(item) {
      if (item.room_category) return item.room_category.description

      const categories = (item.reserves || [])
        .map(reserve => reserve.room_category && reserve.room_category.description)
        .filter(Boolean)

      return [...new Set(categories)].join(', ') || 'Não informada'
    },

    reserved(item) {
      const status = this.confirmStatus(item)
      switch (status) {
        case 'confirmed':
          return 'Confirmado'
        case 'precheckin':
          return 'Pré Check-in'
        case 'checkin':
          return 'Checkin'
        case 'checkout':
          return 'Checkout'
        case 'canceled':
          return 'Cancelado'
        case 'pending':
          return 'Pendente'
        case 'no-show':
          return 'No-Show'
      }
    },
    preCheckinComplete(item) {
      if (Array.isArray(item.reserves)) {
        const preCheckins = item.reserves.filter(reserve => reserve.status === 'precheckin')

        return preCheckins.every(reserve => this.preCheckinComplete(reserve))
      }

      const total = Number(item.pre_checkin_total_guests) || 0

      return total === 0 || Number(item.pre_checkin_completed_guests) >= total
    },

    printItem(reserve) {
      reserve.loading_print = true
      this.printVoucher(reserve)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'voucher.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {
          console.log(response)
        })
        .finally(() => {
          this.reserves.forEach(item => {
            item.loading_print = false
          })

          // armegagem para força a reação do vue
          const backup = this.reserves
          this.reserves = []
          this.reserves = backup
        })
    },

    formatDate(date) {
      if (date) {
        const result = new Date(date)

        return result.toLocaleDateString('pt-BR', {
          timeZone: 'UTC',
        })
      }
    },
    selectItem(item) {
      this.selectedItens = []
      this.selectedItens.push(item)
      console.log(this.selectedItens)
    },
    openGroupAccount(group = null) {
      const selectedGroup = group || this.selectedItens[0]
      if (!selectedGroup) return

      this.$router.push({
        name: 'group_account',
        params: { group_id: selectedGroup.id },
      })
    },
    openCreateGroupDialog() {
      this.createCandidates = []
      this.selectedCreateReserves = []
      this.createGroupSearch = ''
      this.createGroupRequester = ''
      this.createGroupObservation = ''
      this.createGroupDialog = true
      this.loadingCreateCandidates = true

      this.getGroupCreationCandidates()
        .then(response => {
          this.createCandidates = response.data
        })
        .catch(error => {
          this.$toast.error(this.apiErrorMessage(error, 'Não foi possível carregar as reservas disponíveis.'))
          this.closeCreateGroupDialog()
        })
        .finally(() => {
          this.loadingCreateCandidates = false
        })
    },
    closeCreateGroupDialog() {
      if (this.savingCreateGroup) return

      this.createGroupDialog = false
      this.createCandidates = []
      this.selectedCreateReserves = []
      this.createGroupSearch = ''
      this.createGroupRequester = ''
      this.createGroupObservation = ''
    },
    saveCreatedGroup() {
      if (this.selectedCreateReserves.length < 2) return

      this.savingCreateGroup = true
      this.createGroupFromReservations({
        reserve_ids: this.selectedCreateReserves.map(reserve => reserve.id),
        requester: this.createGroupRequester || null,
        obs: this.createGroupObservation || null,
      })
        .then(response => {
          this.$toast.success(response.data.message)
          this.savingCreateGroup = false
          this.closeCreateGroupDialog()
          this.initialize()
        })
        .catch(error => {
          this.$toast.error(this.apiErrorMessage(error, 'Não foi possível criar a reserva de grupo.'))
        })
        .finally(() => {
          this.savingCreateGroup = false
        })
    },
    createCandidateFilter(value, search, item) {
      const normalizedSearch = String(search || '').toLocaleLowerCase('pt-BR')
      const searchableValues = [
        item.id,
        item.company && item.company.fantasy_name,
        item.requester,
        item.room_category && item.room_category.description,
        this.allGuests(item),
      ]

      return searchableValues.some(candidate => String(candidate || '')
        .toLocaleLowerCase('pt-BR')
        .includes(normalizedSearch))
    },
    openJoinDialog(group) {
      this.joinGroup = group
      this.joinCandidates = []
      this.selectedJoinReserves = []
      this.joinSearch = ''
      this.joinDialog = true
      this.loadingJoinCandidates = true

      this.getGroupJoinCandidates(group.id)
        .then(response => {
          this.joinCandidates = response.data
        })
        .catch(error => {
          this.$toast.error(this.apiErrorMessage(error, 'Não foi possível carregar as reservas disponíveis.'))
          this.closeJoinDialog()
        })
        .finally(() => {
          this.loadingJoinCandidates = false
        })
    },
    closeJoinDialog() {
      if (this.savingJoin) return

      this.joinDialog = false
      this.joinGroup = null
      this.joinCandidates = []
      this.selectedJoinReserves = []
      this.joinSearch = ''
    },
    saveJoinedReserves() {
      if (!this.joinGroup || this.selectedJoinReserves.length === 0) return

      this.savingJoin = true
      this.attachReservationsToGroup({
        groupId: this.joinGroup.id,
        reserveIds: this.selectedJoinReserves.map(reserve => reserve.id),
      })
        .then(response => {
          this.$toast.success(response.data.message)
          this.savingJoin = false
          this.closeJoinDialog()
          this.initialize()
        })
        .catch(error => {
          this.$toast.error(this.apiErrorMessage(error, 'Não foi possível adicionar as reservas ao grupo.'))
        })
        .finally(() => {
          this.savingJoin = false
        })
    },
    apiErrorMessage(error, fallback) {
      const response = error && error.response
      const errors = response && response.data && response.data.errors
      const firstError = errors && Object.values(errors)[0]

      return (Array.isArray(firstError) ? firstError[0] : firstError)
        || (response && response.data && response.data.message)
        || fallback
    },
    joinCandidateFilter(value, search, item) {
      const normalizedSearch = String(search || '').toLocaleLowerCase('pt-BR')
      const searchableValues = [
        item.id,
        item.requester,
        item.room_category && item.room_category.description,
        this.allGuests(item),
      ]

      return searchableValues.some(candidate => String(candidate || '')
        .toLocaleLowerCase('pt-BR')
        .includes(normalizedSearch))
    },
    getIds(item) {
      const ids = []
      item.reserves.forEach(reserve => {
        ids.push(reserve.id)
      })

      return ids.join(' - ')
    },
    confirmStatus(item) {
      const { reserves } = item
      const total = reserves.length
      const status = {
        checkin: 0,
        checkout: 0,
        canceled: 0,
        'no-show': 0,
        confirmed: 0,
        precheckin: 0,
        pending: 0,
      }

      reserves.forEach(reserve => {
        if (reserve.status == 'checkin') {
          status.checkin++
        } else if (reserve.status == 'checkout') {
          status.checkout++
        } else if (reserve.status == 'canceled') {
          status.canceled++
        } else if (reserve.status == 'no-show') {
          status['no-show']++
        } else if (reserve.status == 'precheckin') {
          status.precheckin++
        } else if (reserve.status == 'pending') {
          status.pending++
        } else if (reserve.status == 'confirmed') {
          status.confirmed++
        }
      })

      // Se todas estão canceladas, retorna cancelado
      if (status.canceled === total) {
        return 'canceled'
      }

      // Ignora as canceladas e calcula baseado nas não-canceladas
      const totalNonCanceled = total - status.canceled

      if (status.checkin === totalNonCanceled) {
        return 'checkin'
      } if (status.checkout === totalNonCanceled) {
        return 'checkout'
      } if (status['no-show'] === totalNonCanceled) {
        return 'no-show'
      } if (status.precheckin === totalNonCanceled) {
        return 'precheckin'
      } if (status.pending === totalNonCanceled) {
        return 'pending'
      } if (status.confirmed === totalNonCanceled) {
        return 'confirmed'
      }

      // Status misto (combinação de diferentes status, ignorando cancelados)
      return 'misto'
    },

    getMixedStatusChips(item) {
      const { reserves } = item
      const status = {
        checkin: 0,
        checkout: 0,
        'no-show': 0,
        confirmed: 0,
        precheckin: 0,
        pending: 0,
      }

      // Conta os status ignorando cancelados
      reserves.forEach(reserve => {
        if (reserve.status == 'checkin') {
          status.checkin++
        } else if (reserve.status == 'checkout') {
          status.checkout++
        } else if (reserve.status == 'no-show') {
          status['no-show']++
        } else if (reserve.status == 'precheckin') {
          status.precheckin++
        } else if (reserve.status == 'pending') {
          status.pending++
        } else if (reserve.status == 'confirmed') {
          status.confirmed++
        }
      })

      // Calcula o total de não cancelados
      const totalNonCanceled = status.confirmed + status.checkin + status.checkout + status['no-show'] + status.precheckin + status.pending

      // Monta array de chips com os status que existem
      const chips = []

      if (status.confirmed > 0) {
        chips.push({
          color: 'info',
          label: `${status.confirmed} Confirmado${status.confirmed > 1 ? 's' : ''}`,
        })
      }

      if (status.precheckin > 0) {
        chips.push({
          color: this.preCheckinComplete(item) ? '#6CBF84' : '#FB8C00',
          textColor: this.preCheckinComplete(item) ? '#1F4D2E' : '#FFFFFF',
          label: `${status.precheckin} Pré Check-in${status.precheckin > 1 ? 's' : ''}`,
        })
      }

      if (status.checkin > 0) {
        chips.push({
          color: 'success',
          label: `${status.checkin} Check-in${status.checkin > 1 ? 's' : ''}`,
        })
      }

      if (status.checkout > 0) {
        chips.push({
          color: 'error',
          label: `${status.checkout} Check-out${status.checkout > 1 ? 's' : ''}`,
        })
      }

      if (status.pending > 0) {
        chips.push({
          color: 'orange',
          label: `${status.pending} Pendente${status.pending > 1 ? 's' : ''}`,
        })
      }

      if (status['no-show'] > 0) {
        chips.push({
          color: 'warning',
          label: `${status['no-show']} No-Show${status['no-show'] > 1 ? 's' : ''}`,
        })
      }

      return chips
    },

  },
}
</script>

<style scoped>
.group-toolbar {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 20px 16px;
  border-bottom: 1px solid rgba(94, 86, 105, 0.14);
}

.group-toolbar__heading {
  flex: 0 0 auto;
}

.group-toolbar__heading h1 {
  margin: 0;
  color: rgba(58, 53, 65, 0.9);
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.4;
}

.group-toolbar__heading p {
  margin: 2px 0 0;
  color: rgba(58, 53, 65, 0.68);
  font-size: 0.8125rem;
}

.group-toolbar__controls {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.group-toolbar__search {
  flex: 1 1 360px;
  max-width: 560px;
}

.group-toolbar__new-button {
  flex: 0 0 auto;
}

.group-row-actions {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0;
  white-space: nowrap;
}

.group-row-actions__add,
.group-row-actions__account {
  min-width: 0 !important;
  padding-right: 8px !important;
  padding-left: 8px !important;
}

.create-group-fields {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(240px, 1fr);
  gap: 12px;
}

.create-group-dialog {
  max-height: calc(100vh - 48px);
}

::v-deep .create-group-table .v-data-table__wrapper {
  overflow-x: auto;
}

::v-deep .create-group-table table {
  min-width: 900px;
}

.card-tab {
  min-height: 420px;
  min-width: 736px;
}

.tool_table_fam {
  height: 50px;
}

@media (max-width: 959px) {
  .group-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 16px;
  }

  .group-toolbar__controls {
    align-items: stretch;
  }

  .group-toolbar__search {
    max-width: none;
  }
}

@media (max-width: 599px) {
  .group-toolbar__controls,
  .create-group-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .group-toolbar__search {
    flex-basis: auto;
  }

  .group-toolbar__new-button {
    width: 100%;
  }

  .create-group-fields {
    grid-template-columns: 1fr;
  }

  .create-group-actions .v-btn {
    width: 100%;
  }
}
</style>
